/**
 * Runtime widget for pages that will be published soon.
 */
Vue.asyncComponent('cms-dashboard-upcoming-pages-online', {
    props: {
        title: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            default: () => [],
        },
        moreHref: {
            type: String,
            default: '',
        },
        moreLabel: {
            type: String,
            default: '',
        },
        emptyText: {
            type: String,
            default: '',
        },
    },
}, 'cms/dashboard/live/cms-dashboard-upcoming-pages-online.html');
